import { css } from "twin.macro"
import IActionPlay from "@/assets/action_play.svg?react"
import IActionStop from "@/assets/action_stop.svg?react"
import IAddCreative from "@/assets/add_creative.svg?react"
import IAddSubRows from "@/assets/add_sub_rows.svg?react"
import IAddNewUser from "@/assets/add_new_user.svg?react"
import IArrowDown from "@/assets/arrow_down.svg?react"
import IArrowLeftSQ from "@/assets/arrow_left_square.svg?react"
import IArrowLeft from "@/assets/arrow_left.svg?react"
import IArrowRight from "@/assets/arrow_right.svg?react"
import IAutoSyncOff from "@/assets/auto_sync_off.svg?react"
import IAutoSyncOn from "@/assets/auto_sync_on.svg?react"
import IBin from "@/assets/bin.svg?react"
import IBlock from "@/assets/block.svg?react"
import ICarouselArrowLeft from "@/assets/carousel_arrow_left.svg?react"
import ICarouselArrowRight from "@/assets/carousel_arrow_right.svg?react"
import ICancelBooking from "@/assets/cancel_booking.svg?react"
import ICheck from "@/assets/check.svg?react"
import ICheckRound from "@/assets/check_round.svg?react"
import IClose from "@/assets/close.svg?react"
import ICode from "@/assets/code.svg?react"
import IContractUpCumming from "@/assets/contract_up_cumming.svg?react"
import IDanger from "@/assets/danger.svg?react"
import IDocument from "@/assets/document.svg?react"
import IDrag from "@/assets/drag.svg?react"
import IEdit from "@/assets/edit.svg?react"
import IEmpty from "@/assets/empty.svg?react"
import IEnforceCriteriaOff from "@/assets/enforce_criteria_off.svg?react"
import IEnforceCriteriaOn from "@/assets/enforce_criteria_on.svg?react"
import IError404 from "@/assets/e404.svg?react"
import IError500 from "@/assets/e500.svg?react"
import IError504 from "@/assets/e504.svg?react"
import IExclamationTriangle from "@/assets/exclamation_triangle.svg?react"
import IExclamationRound from "@/assets/exclamation_round.svg?react"
import IExpand from "@/assets/expand.svg?react"
import IExternalLink from "@/assets/external_link.svg?react"
import IFilter from "@/assets/filter.svg?react"
import IFrameTargeting from "@/assets/frame_targeting.svg?react"
import IImage from "@/assets/image.svg?react"
import IImageFilled from "@/assets/image_filled.svg?react"
import IInstalled from "@/assets/installed.svg?react"
import ILandscape from "@/assets/landscape.svg?react"
import ILoading from "@/assets/loading.svg?react"
import ILock from "@/assets/lock.svg?react"
import ILogoTextScheduler from "@/assets/logo_seedooh_scheduler.svg?react"
import ILogoSquareScheduler from "@/assets/logo_square_scheduler.svg?react"
import IMenuAllCampaigns from "@/assets/menu_all_campaigns.svg?react"
import IMenuArtchase from "@/assets/menu_artchase.svg?react"
import IMenuCreativeManager from "@/assets/menu_creative_manager.svg?react"
import IMenuCustomerManager from "@/assets/menu_customer_manager.svg?react"
import IMenuInventoryManagement from "@/assets/menu_inventory_management.svg?react"
import IMenuOverview from "@/assets/menu_overview.svg?react"
import IMoreVertical from "@/assets/more_vertical.svg?react"
import IMore from "@/assets/more.svg?react"
import IPlays from "@/assets/plays.svg?react"
import IPlus from "@/assets/plus.svg?react"
import IPortrait from "@/assets/portrait.svg?react"
import IProhibition from "@/assets/prohibition.svg?react"
import IRatio from "@/assets/ratio.svg?react"
import IRatioOff from "@/assets/ratio_off.svg?react"
import IResultFailed from "@/assets/result_failed.svg?react"
import IResultReset from "@/assets/result_reset.svg?react"
import IResultSuccess from "@/assets/result_success.svg?react"
import ISchedule from "@/assets/schedule.svg?react"
import ISearch from "@/assets/search.svg?react"
import ISeedooh from "@/assets/seedooh_logo.svg?react"
import ISend from "@/assets/send.svg?react"
import ISortDown from "@/assets/sort_down.svg?react"
import ISplit from "@/assets/split.svg?react"
import ISquareP from "@/assets/P.svg?react"
import ISync from "@/assets/sync.svg?react"
import ITrash from "@/assets/trash.svg?react"
import ITriAngleDown from "@/assets/triangle_down.svg?react"
import IUndo from "@/assets/undo.svg?react"
import IUnlock from "@/assets/unblock.svg?react"
import IUpload from "@/assets/upload.svg?react"
import IUserMockup from "@/assets/user_mockup.svg?react"
import IZoomIn from "@/assets/zoom_in.svg?react"
import IZoomOut from "@/assets/zoom_out.svg?react"

const OverrideColor = {
    path: css`
        path {
            fill: currentColor;
        }
    `,
    pathStroke: css`
        path {
            stroke: currentColor;
        }
    `,
    use: css`
        use {
            fill: currentColor;
        }
    `,
    rect: css`
        rect {
            fill: currentColor;
        }
    `,
    fill: css`
        svg {
            fill: currentColor;
        }
    `,
    none: css``
}

export default {
    arrow_left_square: [IArrowLeftSQ, OverrideColor.path],
    arrow_left: [IArrowLeft, OverrideColor.path],
    arrow_right: [IArrowRight, OverrideColor.path],
    carousel_arrow_left: [ICarouselArrowLeft, OverrideColor.path],
    carousel_arrow_right: [ICarouselArrowRight, OverrideColor.path],
    arrow_down: [IArrowDown, OverrideColor.path],
    check: [ICheck, OverrideColor.path],
    check_round: [ICheckRound, OverrideColor.path],
    close: [IClose, OverrideColor.path],
    contract_up_cumming: [IContractUpCumming, OverrideColor.none],
    danger: [IDanger, OverrideColor.path],
    document: [IDocument, OverrideColor.path],
    empty: [IEmpty, OverrideColor.none],
    exclamation_triangle: [IExclamationTriangle, OverrideColor.path],
    exclamation_round: [IExclamationRound, OverrideColor.path],
    expand: [IExpand, OverrideColor.path],
    menu_all_campaigns: [IMenuAllCampaigns, OverrideColor.none],
    menu_artchase: [IMenuArtchase, OverrideColor.none],
    menu_creative_manager: [IMenuCreativeManager, OverrideColor.none],
    menu_customer_manager: [IMenuCustomerManager, OverrideColor.none],
    menu_inventory_management: [IMenuInventoryManagement, OverrideColor.none],
    menu_overview: [IMenuOverview, OverrideColor.none],
    image: [IImage, OverrideColor.path],
    image_filled: [IImageFilled, OverrideColor.path],
    landscape: [ILandscape, OverrideColor.path],
    loading: [ILoading, OverrideColor.none],
    logo_scheduler: [ILogoTextScheduler, OverrideColor.none],
    logo_square_scheduler: [ILogoSquareScheduler, OverrideColor.path],
    prohibition: [IProhibition, OverrideColor.path],
    schedule: [ISchedule, OverrideColor.pathStroke],
    search: [ISearch, OverrideColor.path],
    seedooh: [ISeedooh, OverrideColor.path],
    sort_down: [ISortDown, OverrideColor.path],
    sync: [ISync, OverrideColor.path],
    portrait: [IPortrait, OverrideColor.path],
    triangle_down: [ITriAngleDown, OverrideColor.path],
    zoom_in: [IZoomIn, OverrideColor.path],
    zoom_out: [IZoomOut, OverrideColor.path],
    installed: [IInstalled, OverrideColor.path],
    plays: [IPlays, OverrideColor.path],
    external_link: [IExternalLink, OverrideColor.path],
    add_creative: [IAddCreative, OverrideColor.path],
    trash: [ITrash, OverrideColor.path],
    upload: [IUpload, OverrideColor.path],
    filter: [IFilter, OverrideColor.path],
    drag: [IDrag, OverrideColor.path],
    add_new_user: [IAddNewUser, OverrideColor.path],
    lock: [ILock, OverrideColor.path],
    user_mockup: [IUserMockup, OverrideColor.none],
    result_success: [IResultSuccess, OverrideColor.none],
    result_failed: [IResultFailed, OverrideColor.none],
    result_reset: [IResultReset, OverrideColor.none],
    error_404: [IError404, OverrideColor.none],
    error_500: [IError500, OverrideColor.none],
    error_504: [IError504, OverrideColor.none],
    block: [IBlock, OverrideColor.path],
    unblock: [IUnlock, OverrideColor.path],
    undo: [IUndo, OverrideColor.path],
    code: [ICode, OverrideColor.path],
    edit: [IEdit, OverrideColor.path],
    cancel_booking: [ICancelBooking, OverrideColor.path],
    ratio: [IRatio, OverrideColor.path],
    ratio_off: [IRatioOff, OverrideColor.path],
    bin: [IBin, OverrideColor.path],
    more: [IMore, OverrideColor.path],
    more_vertical: [IMoreVertical, OverrideColor.path],
    send: [ISend, OverrideColor.path],
    split: [ISplit, OverrideColor.path],
    auto_sync_on: [IAutoSyncOn, OverrideColor.path],
    auto_sync_off: [IAutoSyncOff, OverrideColor.path],
    add_sub_rows: [IAddSubRows, OverrideColor.path],
    action_play: [IActionPlay, OverrideColor.path],
    action_stop: [IActionStop, OverrideColor.path],
    plus: [IPlus, OverrideColor.path],
    frame_targeting: [IFrameTargeting, OverrideColor.path],
    enforce_criteria_on: [IEnforceCriteriaOn, OverrideColor.path],
    enforce_criteria_off: [IEnforceCriteriaOff, OverrideColor.path],
    square_p: [ISquareP, OverrideColor.path]
}
